import { reactive } from "vue";
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode'; // Importa jwtDecode
import axios from "axios";
import router from "../../routes";
import { Toast } from "../toast/toast";
import { Dashboard } from "../dashboard/dashboard";


export const Auth = reactive({

    loading: false,

    data: {

        // M37: login dual — email o identificación (XOR validado server-side, §9.53)
        mode: 'email' as 'email' | 'identification',

        username: {
            value: "",
            focus: false
        },

        password: {
            value: "",
            focus: false
        },

        country: {
            loading: false,
            value: '',
            values: [] as Array<{id: string; label: string; iso_alpha2: string}>,
        },

        identification_type: {
            loading: false,
            value: '',
            values: [] as Array<{id: string; label: string; country: string | null; sys_code: string}>, // M37.4: +sys_code (default DNI)
        },

        number: {
            value: "",
            focus: false
        },

    },

    setMode(mode: 'email' | 'identification'): void {
        this.data.mode = mode;
        if(mode === 'identification') this.loadCatalogs();
    },

    /** M37: catálogos públicos para el login por identificación (countries + identification-types son @SkipAuth) */
    async loadCatalogs(): Promise<void> {

        if(this.data.country.values.length > 0) return;

        this.data.country.loading = true;
        this.data.identification_type.loading = true;

        const params = { page: 1, page_size: 1000000 };

        await axios.get(`/countries`, { params }).then(res => {
            this.data.country.values = res.data.data.map((x: any) => ({
                id: x.id,
                label: `${x.name}`,
                iso_alpha2: x.iso_alpha2
            }));
            if(this.data.country.values.length > 0 && !this.data.country.value) {
                // M37.4: país por defecto Argentina (si no existe, el primero)
                const ar = this.data.country.values.find(c => c.iso_alpha2 === 'AR');
                this.data.country.value = (ar ?? this.data.country.values[0]).id;
            }
        }).catch(err => {
            console.dir(err);
        });

        await axios.get(`/identification-types`, { params }).then(res => {
            this.data.identification_type.values = res.data.data.map((x: any) => ({
                id: x.id,
                label: `${x.name}`,
                country: x.country || null,
                sys_code: x.sys_code
            }));
            // M37.4: tipo por defecto DNI argentino (si no existe, el primero filtrado)
            if(this.data.identification_type.values.length > 0 && !this.data.identification_type.value)
                this.data.identification_type.value = this.defaultIdTypeId();
        }).catch(err => {
            console.dir(err);
        });

        this.data.country.loading = false;
        this.data.identification_type.loading = false;

    },

    /** M37.1: país seleccionado (bandera del selector, diseño ui-enrollment identity.vue) */
    selectedCountry(): {id: string; label: string; iso_alpha2: string} | null {
        return this.data.country.values.find(c => c.id === this.data.country.value) ?? null;
    },

    /** M37.4: tipo de documento por defecto — DNI de Argentina (cubre las variantes
     *  de datos: sys_code 'AR:DNI', id 'AR_DNI', o country 'AR' + sys_code 'DNI');
     *  fallback: primer tipo filtrado por el país */
    defaultIdTypeId(): string {
        const country = this.data.country.value;
        const all = this.data.identification_type.values;
        const dni = all.find(v => v.sys_code === 'AR:DNI')
            ?? all.find(v => v.id === 'AR_DNI')
            ?? all.find(v => v.country === country && v.sys_code === 'DNI')
            ?? all.find(v => v.sys_code === 'DNI');
        return (dni ?? this.filteredIdTypes()[0])?.id ?? '';
    },

    /** M37: tipos de documento filtrados por el país seleccionado */
    filteredIdTypes(): Array<{id: string; label: string; country: string | null}> {
        const c = this.data.country.value;
        return this.data.identification_type.values.filter(v => !v.country || v.country === c);
    },

    async login(): Promise<void> {

        if(this.loading) return;

        // M37: login dual — se envía email O identification (nunca ambos)
        if(this.data.mode === 'identification' &&
            (!this.data.country.value || !this.data.identification_type.value || !this.data.number.value)) {
            Toast.error(`Datos incompletos`, `Seleccioná país, tipo de documento e ingresá el número.`);
            return;
        }

        this.loading = true;

        const data: any = {
            password: this.data.password.value
        };

        if(this.data.mode === 'email') {
            data.email = this.data.username.value;
        } else {
            data.identification = {
                country: this.data.country.value,
                type: this.data.identification_type.value,
                number: this.data.number.value
            };
        }

        await axios.post(`/auth/login`, data).then(async res => {

            const access_token = res.data.access_token;
            Cookies.set('sgi-access-token', access_token, {expires: 7, secure: true, sameSite: 'Lax'});

            await Dashboard.splash.initialize();

            router.replace({name: 'Dashboard'})


            // return;

            // const token = jwtDecode<any>(access_token);
            // console.dir(token);



            // const allowed_roles = ['sys:root', 'sys:admin', 'CLIENT', 'ADMIN'];
            // const user_roles = token.roles as Array<string>;

            // const has_permission = user_roles && user_roles.some(role => allowed_roles.includes(role));

            // if(has_permission) {

            //     // Cookies.set('sgi-access-token', res.data.token, {expires: 7, secure: import.meta.env.PROD, sameSite: 'Lax'});
            //     Cookies.set('sgi-access-token', access_token, {expires: 7, secure: true, sameSite: 'Lax'});
            //     // Toast.success(`Ingreso exitoso`, `Bienvenido ${token.username}.`);

            //     const a = ['ROOT', 'SUPER'];
            //     const b = ['CLIENT', 'ADMIN'];

            //     const resA = user_roles && user_roles.some(role => a.includes(role));
            //     const resB = user_roles && user_roles.some(role => b.includes(role));

            //     if(resA)
            //         router.replace({name: 'ClientsList'})
            //     else if(resB)
            //         router.replace({name: 'ServiceList'})

            //     this.data.username.value = '';
            //     this.data.password.value = '';

            // }else {

            //     Toast.error(`Usuario no Autorizado`, `Tu usuario no tiene permisos para ingresar a esta sección.`);

            // }

        }).catch(err => {

            console.dir(err);

            const status = err.response?.status;

            if(status === 401)
                // M37: mensaje genérico anti-enumeración (mismo para usuario inexistente / clave incorrecta)
                Toast.error(`Error al Ingresar`, `Credenciales inválidas.`);

            else if(status === 429)
                // M37: rate limiting del backend (AUTH_RATE_LIMIT_*)
                Toast.error(`Demasiados intentos`, `Superaste el límite de intentos. Esperá unos minutos e intentá de nuevo.`);

            else
                Toast.error(`Error al Ingresar`, `Ocurrio un error code ${status ?? 'desconocido'} en el servidor, contacte al soporte técnico.`);

        })

        this.loading = false;

    },

    async logout(): Promise<void> {

        // --- ELIMINAR SOLO EL TOKEN JWT DE LA COOKIE ---
        Cookies.remove('sgi-user-profiles', {path: '/'});
        Cookies.remove('sgi-access-token', { path: '/' });
        Cookies.remove('sgi-organization', { path: '/' });
        console.log('Sesión cerrada. Token JWT eliminado de cookie.');
        router.replace({ name: 'AuthLogin' });

        setTimeout(() => {
            router.go(0);
        }, 200);

    },

    async getToken(decoded = true): Promise<any | null> {

        const token = Cookies.get('sgi-access-token');

        if(!token) return null;

        try {

            const decoded_token = jwtDecode<any>(token);
            const current_time = Date.now() / 1000;

            if(decoded_token.exp && decoded_token.exp < current_time) {

                console.log('Token JWT expirado.');
                Toast.error('Sesión Expirada', 'Su sesión expiró, ingrese nuevamente su usuario y contraseña.');
                this.logout();

                return null;

            }else {

                // console.log('Token JWT válido.');
                // console.log(decoded_token);
                if(decoded)
                    return decoded_token;
                else
                    return token;

            }

        }catch(err) {

            console.log('Error al decodificar JWT o token inválido:', err);
            this.logout();
            return null;

        }

    },

    async getProfiles(): Promise<string[]> {

        const data = Cookies.get('sgi-user-profiles');

        if(!data)
            return [];

        const profiles = JSON.parse(data);
        return profiles;

    },

    async isAuthenticated(): Promise<boolean> {

        const token = await this.getToken();
        if(!token) return false;
        return true;

    },

    async isAuthorized(allowed_roles: Array<string>): Promise<boolean> {

        // const token = await this.getToken();
        // if(!token) return false;

        // const user_roles: Array<string> = token.roles;
        const user_roles: Array<string> = await this.getProfiles();
        // console.log(user_roles);

        // console.log(user_roles);

        if(allowed_roles && allowed_roles.length > 0) {

            // console.log(allowed_roles);

            const has_permission = user_roles && user_roles.some(role => allowed_roles.includes(role));

            if(!has_permission) {
                // console.log(`Acceso denegado: El usuario con roles [${user_roles?.join(', ')}] no está autorizado.`);
                return false;
            }

        }

        return true;

    }

})